import React, { useContext } from 'react';
// MUI
import { Card, CardContent, Grid, Typography } from '@mui/material';
import useProductSamplingv2Context from '../context/useProductSamplingv2Context';
import { numberFormat } from '../../../helpers/helperFunctions';

function SummaryCard({ title, value, subtitle, color }) {
  return (
    <Card
      variant='outlined'
      sx={{
        height: '100%',
        borderRadius: 2,
      }}
    >
      <CardContent>
        <Typography
          variant='caption'
          sx={{
            letterSpacing: 1,
            fontWeight: 700,
            color: 'text.secondary',
          }}
        >
          {title}
        </Typography>

        <Typography
          sx={{
            mt: 1,
            fontSize: 38,
            lineHeight: 1,
            fontWeight: 500,
            color,
          }}
        >
          {value}
        </Typography>

        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          {subtitle}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default function RequestSummary() {
  const { summary } = useContext(useProductSamplingv2Context);
  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={12} md={3}>
        <SummaryCard
          title='PLANS THIS MONTH'
          value={numberFormat(summary?.plan_requested)}
          subtitle={summary?.category
            ?.map((item) => `${item.plan_requested} ${item.category}`)
            .join(' · ')}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <SummaryCard
          title='TOTAL ITEMS'
          value={numberFormat(summary?.total_items)}
          subtitle='across all plans'
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <SummaryCard
          title='REQUESTED QTY'
          value={numberFormat(summary?.requested_qty)}
          subtitle='pcs requested'
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <SummaryCard
          title='CONFIRMED QTY'
          value={numberFormat(summary?.confirmed_qty)}
          subtitle='pcs confirmed by warehouse'
          color='#2E7D32'
        />
      </Grid>
    </Grid>
  );
}
